import type { types } from "@fraction/shared";
import { openDetachedWindow } from "src/lib/runtime/detachedWindows";
import { isTauriRuntime } from "src/lib/runtime/environment";

export const WORKFLOW_CONFIRMATION_SURFACE = "workflow-confirmation";

export type WorkflowConfirmationWindowPayload = types.WorkflowConfirmationRequestNotification;

/**
 * Open a workflow confirmation in its own window, or report that there isn't one to open.
 *
 * The caller asks for the confirmation to be shown and this decides how — the same shape as
 * `usePreviewDocument` and `openAgentSessionWithPreference`. Deciding here rather than inside a
 * rendered modal means a caller cannot accidentally get the modal by being somewhere that modal
 * isn't mounted.
 */
export function openWorkflowConfirmationWindow(payload: WorkflowConfirmationWindowPayload): boolean {
  if (!isTauriRuntime()) return false;

  void openDetachedWindow({
    surface: WORKFLOW_CONFIRMATION_SURFACE,
    // One window per confirmation: a second notification for the same question focuses the window
    // already asking it rather than opening a rival copy of the same decision.
    instanceKey: `confirmation:${payload.confirmationId}`,
    payload,
    title: payload.workflowName ? `Confirm · ${payload.workflowName}` : "Confirmation needed",
    width: 620,
    height: 560,
    minWidth: 460,
    minHeight: 380,
    placement: "cascade",
  }).catch((error) => console.warn("Could not open the workflow confirmation window.", error));
  return true;
}
